import { render, staticRenderFns } from "./OrderSettlement.vue?vue&type=template&id=e72ace7a&scoped=true&"
import script from "./OrderSettlement.vue?vue&type=script&lang=js&"
export * from "./OrderSettlement.vue?vue&type=script&lang=js&"
import style0 from "./OrderSettlement.vue?vue&type=style&index=0&id=e72ace7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72ace7a",
  null
  
)

export default component.exports